import { useNavigate, useParams } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditCademiForm from "../../../components/apps/cademi/EditCademiForm";

export default function EditCademi() {
    const navigate = useNavigate();
    const { cademiId } = useParams();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/cademi`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Cademi"
                description="Editar cademi"
            />
            <PageBreadcrumb
                pageTitle="Editar Cademi"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditCademiForm
                    cademiId={cademiId}
                    onSuccess={() => {
                        // Redirecionar para a página de listagem de cademis
                        navigate(`/apps/cademi`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao atualizar cademi:", error);
                    }}
                />
            </div>
        </>
    );
}